import { Box } from '@mui/material';
import { createMRTColumnHelper } from 'material-react-table';
import React from 'react';
import { format } from 'date-fns';
import commaNumber from 'comma-number';
import CummonTable from '../../Common/CummonTable';

const DepositList = ({ data }) => {
  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor('depositId', {
      header: 'Deposit Id',
      Cell: ({ row }) => (
        <button
          style={{
            background: 'gray',
            borderRadius: '5px',
            padding: '2px 10px',
            width: '120px',
            cursor: 'pointer',
            border: 'none',
            color: 'var(--white)',
          }}
        >
          {row.original.depositId}
        </button>
      ),
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
    columnHelper.accessor('sender', {
      header: 'Sender',
      size: '10px',
    }),
    columnHelper.accessor('amount', {
      header: 'Amount',
      Cell: ({ row }) => `${commaNumber(row.original.amount) + 'AED' || '0'}`,
    }),
    columnHelper.accessor('created_at', {
      header: 'Time',
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
  ];

  return (
    <div>
      <Box
        sx={{
          boxSizing: 'border-box',
        }}
      >
        <CummonTable data={data} columns={columns} pageSize={5} />
      </Box>
    </div>
  );
};

export default DepositList;
